export const formatAmount = (amount: number) =>
  amount.toLocaleString('en-US', {
    style: 'decimal',
  });

export const formatPrice = (price: number) =>
  price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3,
  });

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  const formattedDate = date.toLocaleString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return formattedDate;
};
